module.exports = __webpack_public_path__ + "img/Rectangle 1212 (8)-compressed.71cd76a0.jpg";